// extracted by mini-css-extract-plugin
module.exports = {"appSeller":"VppSoftwareAppsAsidePanel__appSeller","centered":"VppSoftwareAppsAsidePanel__centered"};